import React from "react";
import PageWrapper from "../pageWrapper";
//CSS
import "../0PageStyles.css";

//Components
import ItemView from "../../Components/Item Components/itemView";

//Functions and hooks
import { useTranslation } from "react-i18next";

export default function ItemPage() {
  const { t } = useTranslation();

  const tutorialSteps = [
    {
      target: null,
      title: t("Your items", { ns: "tutorial" }),
      message: t(
        "This is your Items page - every product or material you track lives here. Let's take a quick look around.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".search-bar-container",
      title: t("Search", { ns: "tutorial" }),
      message: t(
        "Search for an item by name, ID, or barcode. The list filters as you type.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".sortAndFilterBar",
      title: t("Sort and filter", { ns: "tutorial" }),
      message: t(
        "Sort the list by ID, name, amount, or price, and use Filters to narrow items down by tags or other properties.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".item-card-container .Card:first-child",
      title: t("Item rows", { ns: "tutorial" }),
      message: t(
        "Each row is one item, with its ID, name, barcode, price, tags, and total stock across all warehouses. Click Edit on a row to change its details.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".CardHeader .btn-positive",
      title: t("Create"),
      message: t(
        "Add a brand new item to your inventory here.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".export-container",
      title: t("Export"),
      message: t(
        "Export the current item list to Excel or CSV - this respects whatever search, filter, and sort you've currently applied.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="items" tutorialSteps={tutorialSteps}>
      <div className="page-content ">
        <div className="view-page-container ">
          <ItemView bShowAll={true} />
        </div>
      </div>
    </PageWrapper>
  );
}
